import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { ReportTemplateModel, ReportTemplatePayload } from "src/app/models/reports";
import { TableColumn } from "src/app/models/table";

@Component({
    selector: 'mwp-report-builder-templates',
    templateUrl: './report-builder-templates.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportBuilderTemplatesComponent implements OnInit {
    @Input() public templates: ReportTemplateModel[]
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitSave: EventEmitter<ReportTemplatePayload> = new EventEmitter<ReportTemplatePayload>();

    public formSelectCheckbox: string = 'isSelected';
    public customReportIDName: string = 'customReportID';
    public templateFormArrayName: string = 'templateFormArrayName';
    public templateSelectionForm: FormGroup;
    public tableMatData: MatTableDataSource<ReportTemplateModel> = new MatTableDataSource<ReportTemplateModel>();
    public tableColumns: TableColumn[] = [
        {
            columnName: '',
            propertyId: this.formSelectCheckbox,
            columnType: TableColumnType.checkBox,
            isSingleSelect: true,
            width: '5%',
        },
        {
            columnName: 'Template',
            propertyId: 'name',
            columnType: TableColumnType.label
        },
        {
            columnName: 'Description',
            propertyId: 'description',
            columnType: TableColumnType.label
        },
    ];

    constructor(
        private formBuilder: FormBuilder,
    ) {
    }

    ngOnInit(): void {
        this.tableMatData.data = this.templates;
        const l_FormArray = new FormArray([]);
        this.templates.forEach((item: ReportTemplateModel) => {
            l_FormArray.push(
                this.formBuilder.group({
                    [this.formSelectCheckbox]: [false],
                    name: [item.name],
                    description: [item.description],
                    [this.customReportIDName]: [item.customReportID]
                })
            );
        });

        this.templateSelectionForm = this.formBuilder.group({
            [this.templateFormArrayName]: l_FormArray,
        });
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public save(): void {
        let l_ReportTemplatePayload: ReportTemplatePayload = new ReportTemplatePayload();
        const l_AssignArray = <FormArray>this.templateSelectionForm.get(this.templateFormArrayName) as FormArray;
        l_AssignArray.controls.map((gaa) => {
            if (gaa.get(this.formSelectCheckbox).value) {
                l_ReportTemplatePayload.customReportID = gaa.get(this.customReportIDName).value;
            }
        });

        this.emitSave.emit(l_ReportTemplatePayload);
    }
}